import React from 'react';
import { Check, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface CheckoutConfirmationProps {
  orderId: string;
  email: string;
}

export function CheckoutConfirmation({ orderId, email }: CheckoutConfirmationProps) {
  const navigate = useNavigate();

  return (
    <div className="space-y-6 text-center py-6">
      <div className="rounded-full bg-green-100 p-4 w-24 h-24 mx-auto flex items-center justify-center">
        <Check className="w-12 h-12 text-green-600" />
      </div>
      <h2 className="text-2xl font-bold">Tellimus edukalt esitatud!</h2>
      <p className="text-gray-600">
        Täname sind tellimuse eest. Tellimuse number on: <strong>{orderId}</strong>
      </p>
      <p className="text-gray-600">
        Saatsime kinnituse sinu e-postile: <strong>{email}</strong>
      </p>
      <p className="text-amber-600 text-sm flex justify-center items-center">
        <Mail className="w-4 h-4 mr-1" /> Kontrolli ka rämpsposti kausta!
      </p>
      <div className="mt-8">
        <button
          onClick={() => navigate('/')}
          className="px-8 py-3 bg-[#4FC1E9] text-white rounded-full hover:bg-[#3ba8d0] transition-colors"
        >
          Tagasi avalehele
        </button>
      </div>
    </div>
  );
}